import { useEmitEvent } from '@mntn/event-client/ui'
import { useCallback, useMemo } from 'react'

/**
 * Hook for tracking Flight Deck analytics events
 * Events are sent to select-api, which routes them to Segment → Intercom
 *
 * @example
 * const { trackDashboardViewed } = useFlightDeckAnalytics()
 * trackDashboardViewed({
 *   has_purchased_deals: true,
 *   ready_to_create_campaign: false
 * })
 */
export const useFlightDeckAnalytics = () => {
  const emitEvent = useEmitEvent()

  const trackDashboardViewed = useCallback(
    async (request: { has_purchased_deals: boolean; ready_to_create_campaign: boolean }) => {
      await emitEvent({
        name: 'flight deck dashboard viewed',
        request,
      })
    },
    [emitEvent],
  )

  return useMemo(() => ({ trackDashboardViewed }), [trackDashboardViewed])
}
